var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 26C2 26.2652 2.10536 26.5196 2.29289 26.7071C2.48043 26.8946 2.73478 27 3 27H29C29.2652 27 29.5196 26.8946 29.7071 26.7071C29.8946 26.5196 30 26.2652 30 26V13.875H2V26ZM6.125 17.375C6.125 17.2424 6.17768 17.1152 6.27145 17.0214C6.36521 16.9277 6.49239 16.875 6.625 16.875H12.375C12.5076 16.875 12.6348 16.9277 12.7286 17.0214C12.8223 17.1152 12.875 17.2424 12.875 17.375V21.375C12.875 21.5076 12.8223 21.6348 12.7286 21.7286C12.6348 21.8223 12.5076 21.875 12.375 21.875H6.625C6.49239 21.875 6.36521 21.8223 6.27145 21.7286C6.17768 21.6348 6.125 21.5076 6.125 21.375V17.375ZM29 5H3C2.73478 5 2.48043 5.10536 2.29289 5.29289C2.10536 5.48043 2 5.73478 2 6V10.125H30V6C30 5.73478 29.8946 5.48043 29.7071 5.29289C29.5196 5.10536 29.2652 5 29 5Z",
    fill: "#605BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/cardIcon.fbb9d8d994e23cad48d99bd06d3b94e5.svg";
export { ForwardRef as ReactComponent };